<template>
    <v-row justify="center">
        <v-dialog
                  v-model="dialog"
                  persistent
                  width="auto">
            <v-card>
                <v-card-title class="text-h5" v-if="!!title">{{ title }}</v-card-title>
                <v-card-text v-if="!!text">{{ text }}</v-card-text>
                <v-card-actions>
                    <v-btn
                           color="red-darken-1"
                           variant="text"
                           @click="deny()">
                        Não
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                           color="green-darken-1"
                           variant="text"
                           @click="accept()">
                        Sim
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
export default {
    props: {
        title: String,
        text: String,
        invoices: Array,
    },
    data() {
        return {
            dialog: false,
        }
    },
    emits: ['accepted', 'refused'],
    methods: {
        accept() {
            const vm = this;

            vm.$emit('accepted', vm.invoices);
        },
        deny() {
            const vm = this;

            vm.$emit('refused', vm.invoices);
        },
    },
    watch: {
        invoices: {
            handler(newVal) {
                const vm = this;

                vm.dialog = newVal?.length > 0;
            },
            immediate: true
        }
    }
}
</script>